import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import useParamsGetter from "../../hooks/useParamsGetter";
import useAPI from "../../hooks/useAPI";
import BackBtn from "../UI/BackBtn";
import YearSelect from "../common/YearSelect";
import DownloadLink from "../common/DownloadLink";
import { years } from "../../helpers";
import { getDetailUnifiedCols } from "../../helpers/unified";
import { arrayToLookup, formatDate } from '../../helpers/table';
import { roles } from '../../helpers/factdata';
import DetailUnifiedPc from "./DetailUnifiedPc";
import { BaseRequests } from '../../requests/BaseRequests';
import { getDataByReportType } from "../../requests/UnifiedPcs/unified";
import LoadingTable from '../table/LoadingTable';
import FilterMultiSelect from '../table/FilterMultiSelect';
import { dateRenderer } from '../../services/formatSvc';
import { MTableBody, MTableToolbar } from 'material-table';
import { TableCell, TableRow, TableFooter } from '@material-ui/core';
import MTableHeader from '../material-table-overrides/MTableHeader';
import MTableFilterRow from '../material-table-overrides/MTableFilterRow';
import { renderNullFloatValues } from '../../pages/index/Shared';

const leftValues = [48, 238, 468];

const BaseDetailUnifiedPcs = () => {
    const {countEntity} = useParams()
    const [data, setData]= useState([])
    const api = useAPI()
    const [year, setYear] = useState(2024);
    const [reportType, entityId, type, stratId, portfolioId, projId, policyId, title] = useParamsGetter('reportType', 'entityId', 'type','stratId', 'portfolioId', 'projId', 'policyId', 'indexName')
    const [isLoaded, setIsLoaded] = useState(false);

    const properties = ['contractSum', 'contractSumWithShare', 'paymentOrderSum', 'paymentOrderSumWithShare', 'paymentActSum', 'paymentActSumWithShare'];

    const handleLevel = useCallback((cols) => {
        if (['teamMembers', 'teamMemberCounts'].includes(countEntity) && !!data.length) {
            return cols
                .map((col) => (!['inclusionDate', 'exclusionDate', 'num', 'share'].includes(col.field) ? {
                    ...col,
                    filterComponent: FilterMultiSelect,
                    lookup: arrayToLookup(col.field, data),
                } : col));
        }
        return cols;
    }, [type, data]);

    const getStratName = useCallback((stratId) => {
        switch (stratId) {
            case '1':
                return 'СП1 Материалы и технологии для водородной и ядерной энергетики';
            case '2':
                return 'СП2 Дизайн и технологии функциональных материалов и систем';
            case '3':
                return 'СП3 Благополучие человека в условиях цифровой трансформации';
            case '4':
                return 'СП4 Академическое превосходство';
            case '5':
                return 'СП5 Образование: кадры для научно-технологического прорыва';
            default:
                console.error(`Неизвестный ID стратегического проекта: ${stratId}`)
        }
    }, [])

    const getCols = useCallback(() => {
        switch (countEntity) {
            case 'teamMembers':
            case 'teamMemberCounts':
                return getDetailUnifiedCols(data, countEntity, handleLevel);
            case 'contracts':
                return getDetailUnifiedCols(data, countEntity);
            default:
                return {};
        }
    }, [countEntity, data, handleLevel])

    const sumValues = (result) => {
        let sums = {};
        properties.forEach((item) => {
          let sumsOneArr = [];
          {result?.filter((e) => !e.hasOwnProperty('parentId')).map((e) => {
            sumsOneArr.push(e[item])
          })}
          if (sumsOneArr.length > 0)
          sums[item] = Number(sumsOneArr.reduce((a, b) => { return a + b }))
        })
        return sums;
    }

    const getComponents = () => ({
        Toolbar: (props) => (
            <div style={{ marginTop: '1.5em', marginBottom: '1em' }}>
                <h3 style={styledTitle}>{decodeURI(title)}</h3>
                <div style={styledToolbarContainer}>

                    <div style={styledContainer}>
                        <div style={styledToolbarTitle}>Год</div>
                        <div style={{ width: '100%' }}>
                            <YearSelect
                                year={year}
                                years={[...years.filter((e) => e != 2021)]}
                                onChange={(e) => setYear(e.value)}
                            />
                        </div>
                    </div>

                    <div style={{ width: '100%' }}>
                        <MTableToolbar {...props} />
                    </div>

                    <div style={{ flex: 'none', marginLeft: 16 }}>
                        <DownloadLink
                            variant="outline-primary"
                            url={BaseRequests.getUrlSearch(`/factdata/${countEntity}/0/report/export`, {
                                type: reportType,
                                years: [year],
                                policyId,
                                portfId: portfolioId,
                                strategyId: stratId,
                                projId,
                            })}
                            filename={`${decodeURI(title)}_${dateRenderer(new Date())}.xlsx`}
                        >
                            Выгрузить в Excel
                        </DownloadLink>
                    </div>
                </div>
            </div>
        ),
        Header: (props) => {
            return <MTableHeader {...props} isTreeData={countEntity === 'contracts'} />
        },
        FilterRow: (props) => {
            return <MTableFilterRow {...props} isTreeData={countEntity === 'contracts'} />
        },
        Body: (props) => {
            return <>
                <MTableBody {...props} isTreeData={countEntity === 'contracts'}/>
                {countEntity === 'contracts' && props.renderData.length > 0 && (
                    <TableFooter>
                        <TableRow>
                            <TableCell></TableCell>
                            {props.columns.filter((column) => !column.hidden).map((column, index) => (
                                <TableCell
                                    style={index > 2
                                        ? {color: '#212529', fontWeight: 700, fontSize: 14}
                                        : {color: '#212529', fontWeight: 700, fontSize: 14, position: 'sticky', left: (leftValues[index]), background: 'white', boxShadow: 'rgba(0, 0, 0, 0.15) 5px 0px 5px', zIndex: 15}}
                                    key={index}
                                >
                                    {index === 2 ? 'Итого' : properties.includes(column.field) ? renderNullFloatValues(sumValues(props.renderData)[column.field]) : ""}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableFooter>
                )}
            </>
        },
    });

    useEffect(() => {
        setIsLoaded(false);
        getDataByReportType({
            countEntity,
            reportType,
            entityId,
            type,
            strategyId: stratId,
            portfId: portfolioId,
            projId,
            policyId,
            year,
        }, api)
            .then((res) => {
                !data.length && setData(res.data.map((v, i) => {
                    switch (countEntity) {
                        case 'teamMemberCounts':
                        case 'teamMembers':
                            return {
                                ...v,
                                inclusionDate: formatDate(v.inclusionDate),
                                exclusionDate: formatDate(v.exclusionDate),
                                isYoung: v.isYoung ? 'Да' : 'Нет',
                                role: roles[v.role],
                                fullName: `${v.lastName} ${v.firstName} ${v.middleName}`,
                                projHead: v.proj.head.displayName,
                                projName: `${v.proj.fullNumber} ${v.proj.name}`,
                                strategyName: stratId && !v.hasOwnProperty('parentId') ? getStratName(stratId) : `${v?.proj?.strategyNum || ''} ${v?.proj?.strategyName || ''}`,
                                num: i + 1,
                            }
                        case 'contracts':
                            return {
                                ...v,
                                actualType: v.hasOwnProperty('parentId') ? v?.type : '-',
                                shareNew: v.hasOwnProperty('share') ? v?.share * 100 : '',
                                isPrimaryParticipantTitle: v?.isPrimaryParticipant === true ? 'Да' : v?.isPrimaryParticipant === false ? 'Нет' : '',
                                headsInstitute: v?.personsInCharge?.map((p) => p.institute).join(', '),
                                topicHeads: v?.personsInCharge?.map((p) => p.displayName).join(', '),
                                name: v?.topic || '',
                                projHead: v?.proj?.head.displayName || '',
                                projName: `${v?.proj?.fullNumber || ''} ${v?.proj?.name || ''}`,
                                strategyName: stratId && !v.hasOwnProperty('parentId') ? getStratName(stratId) : `${v?.proj?.strategyNum || ''} ${v?.proj?.strategyName || ''}`,
                                contragentName: v?.contractOrg?.title || '',
                                contragentInn: v?.contractOrg?.inn || '',
                                paymentActsField: v?.paymentActs?.map((p) => `№ ${p.num} от ${formatDate(p.paymentDate)}`).join(',\n') || '',
                                paymentOrdersField: v?.paymentOrders?.map((p) => `№ ${p.num} от ${formatDate(p.paymentDate)}`).join(',\n') || '',
                                paymentOrderSum: v?.paymentOrderSum ? v.paymentOrderSum : '',
                            }
                        default:
                            console.error(`Неизвестная сущность: ${countEntity}`);
                            return {};
                    }
                }));
            })
            .catch((err) => {
                console.error(`Произошла ошибка при загрузке данных: ${err}`);
            })
            .finally(() => setIsLoaded(true));
    }, [year]);

    return (
        <section style={{ padding: '2.5rem 3rem' }} className="page project-page">
            <BackBtn />
            <LoadingTable spinnerStyle={{ marginTop: '50px' }} loadingObject={{ isLoaded }}>
                <DetailUnifiedPc
                    originalData={data}
                    components={getComponents()}
                    title=""
                    cols={getCols()}
                    handleLevel={handleLevel}
                    entity={countEntity}
                />
            </LoadingTable>
        </section>
    );
}

export default BaseDetailUnifiedPcs;

const styledContainer = {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    position: 'relative',
    zIndex: 21,
    minWidth: '144px',
    alignItems: 'start',
};

const styledToolbarContainer = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
};

const styledToolbarTitle = {
    color: 'black',
    fontSize: '16px',
    marginBottom: '5px',
    fontWeight: '600',
};

const styledTitle = {
    marginBottom: '1em',
    fontSize: '20px',
    textAlign: 'start',
};
